import { useState } from 'react';
import SpecialsPopup from './SpecialsPopup';
import GClassPopup from './GClassPopup';
import AMGPopup from './AMGPopup';
import MaybachPopup from './MaybachPopup';
import AllMercedesPopup from './AllMercedesPopup';

export default function Inventory() {
  const [activePopup, setActivePopup] = useState<string | null>(null);

  const categories = [
    {
      id: 'specials',
      title: 'Current Specials',
      description: 'Limited time lease offers on select 2025 models',
      icon: 'ri-fire-line',
      image: 'https://public.readdy.ai/ai/img_res/4bb4dc0889888f810f1918471021a9d4.jpg'
    },
    {
      id: 'gclass',
      title: 'G-Class Collection',
      description: 'The G-Wagon Capital - Largest inventory on the market',
      icon: 'ri-truck-line',
      image: 'https://readdy.ai/api/search-image?query=iconic%20black%20mercedes%20benz%20g%20class%20g%20wagon%20suv%20showcased%20in%20modern%20showroom%20with%20dramatic%20lighting%20emphasizing%20legendary%20boxy%20design%20and%20commanding%20off%20road%20presence%20on%20polished%20dark%20surface%20premium%20dealership%20display&width=800&height=500&seq=cat002&orientation=landscape'
    },
    {
      id: 'amg',
      title: 'AMG Performance',
      description: 'C63, E63, S63, SL63, GT63, G63, GLS63 and many more',
      icon: 'ri-flashlight-line',
      image: 'https://readdy.ai/api/search-image?query=aggressive%20black%20mercedes%20amg%20performance%20sedan%20with%20red%20brake%20calipers%20displayed%20in%20high%20performance%20showroom%20with%20dramatic%20red%20accent%20lighting%20showcasing%20sporty%20aerodynamic%20design%20on%20glossy%20dark%20floor%20racing%20inspired%20automotive%20presentation&width=800&height=500&seq=cat003&orientation=landscape'
    },
    {
      id: 'maybach',
      title: 'Maybach Luxury',
      description: 'Experience the pinnacle of Mercedes-Benz luxury',
      icon: 'ri-vip-crown-line',
      image: 'https://readdy.ai/api/search-image?query=opulent%20black%20mercedes%20maybach%20sedan%20displayed%20in%20ultra%20luxury%20showroom%20with%20elegant%20champagne%20lighting%20showcasing%20elongated%20wheelbase%20and%20exclusive%20maybach%20design%20on%20reflective%20dark%20surface%20ultimate%20automotive%20luxury%20presentation&width=800&height=500&seq=cat004&orientation=landscape'
    },
    {
      id: 'all',
      title: 'All Mercedes-Benz',
      description: 'Hundreds of new and preowned options with order bank access',
      icon: 'ri-car-line',
      image: 'https://readdy.ai/api/search-image?query=diverse%20collection%20of%20mercedes%20benz%20vehicles%20including%20sedans%20suvs%20and%20coupes%20arranged%20in%20expansive%20premium%20showroom%20with%20sophisticated%20lighting%20showcasing%20complete%20mercedes%20lineup%20on%20polished%20dark%20floor%20comprehensive%20automotive%20display&width=800&height=500&seq=cat005&orientation=landscape'
    }
  ];

  const openPopup = (id: string) => {
    setActivePopup(id);
  };

  const closePopup = () => {
    setActivePopup(null);
  };

  return (
    <>
      <section id="inventory" className="py-24 bg-zinc-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Explore Our <span className="text-amber-400">Inventory</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              From exclusive specials to the largest G-Class selection, discover your perfect Mercedes-Benz
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map(category => (
              <div
                key={category.id}
                onClick={() => openPopup(category.id)}
                className="bg-zinc-800 rounded-lg overflow-hidden shadow-xl hover:shadow-2xl hover:shadow-amber-400/20 transition-all duration-300 group cursor-pointer"
              >
                <div className="relative h-64 w-full overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.title}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/50 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="w-12 h-12 flex items-center justify-center bg-amber-400 rounded-lg mb-3">
                      <i className={`${category.icon} text-black text-2xl`}></i>
                    </div>
                    <h3 className="text-white text-2xl font-bold mb-2">{category.title}</h3>
                    <p className="text-gray-300 text-sm">{category.description}</p>
                  </div>
                </div>
                <div className="p-6">
                  <button className="w-full bg-amber-400 text-black font-semibold py-3 rounded-lg hover:bg-amber-500 transition-colors duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                    <span>Learn More</span>
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SpecialsPopup isOpen={activePopup === 'specials'} onClose={closePopup} />
      <GClassPopup isOpen={activePopup === 'gclass'} onClose={closePopup} />
      <AMGPopup isOpen={activePopup === 'amg'} onClose={closePopup} />
      <MaybachPopup isOpen={activePopup === 'maybach'} onClose={closePopup} />
      <AllMercedesPopup isOpen={activePopup === 'all'} onClose={closePopup} />
    </>
  );
}
